import React from 'react';
import NewServiceComponent from '../modules/new-service';

function NewService(props){
  return <NewServiceComponent {...props}/>
}

export default NewService;